document.querySelectorAll( '[href^="#"]' ).forEach( ( link ) =>
{
    link.addEventListener( "click", function ( e )
    {
        e.preventDefault( );
        const targetId = this.getAttribute( "href" ).substring( 1 );
        const targetElement = document.getElementById( targetId );

        if ( targetElement )
        {
            const headerHeight = document.querySelector( "sticky-header" ).offsetHeight;
            const targetPosition =
                targetElement.getBoundingClientRect( ).top +
                window.scrollY -
                headerHeight;
            window.scrollTo( { top: targetPosition, behavior: "smooth" } );
        }
    });
});

window.addEventListener( "load", function ( )
{
    let adventCalendarOffers;

    function getActiveDayIndex( )
    {
        const slides = document.querySelectorAll( ".advent-calendar-offers__offer" );
        let activeIndex = 0;

        slides.forEach( ( slide, index ) =>
        {
            if ( slide.classList.contains( "advent-calendar-offers__offer-active" ) )
            {
                activeIndex = index;
            }
        });

        return activeIndex;
    }

    function initializeSwiper( )
    {
        if ( window.innerWidth < 750 )
        {
            if ( !adventCalendarOffers )
            {
                const activeIndex = getActiveDayIndex( );

                adventCalendarOffers = new Swiper(
                    ".advent-calendar-offers__offers-swiper",
                    {
                        cssMode: true,
                        slidesPerView: 1.75,
                        spaceBetween: 20,
                        centeredSlides: true,
                        loop: true,
                        initialSlide: activeIndex,
                        navigation:
                        {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        mousewheel: true,
                        keyboard: true,
                    }
                );
            }
        }
        else
        {
            if ( adventCalendarOffers )
            {
                adventCalendarOffers.destroy( true, true );
                adventCalendarOffers = null;
            }
        }
    }

    initializeSwiper( );

    window.addEventListener( "resize", initializeSwiper );
});
